import styled from 'styled-components';

const DenyMessage = (props) => {
    const { message, handleStep } = props;

    return (
        <Container>
            <Title>Motivo de rechazo</Title>
            <Message>{message}</Message>
            <Footer>
                <Button onClick={handleStep}>Actualizar documentación</Button>
            </Footer>
        </Container>
    );
};

export default DenyMessage;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const Title = styled.h3`
    font-size: 20px;
    font-weight: 700;
    color: #b31d15;
    text-align: center;
`;

export const Message = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 2rem);
    padding: 1rem;
    border-radius: 10px;
    border: 1px solid #c4c4c4;
`;

const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
`;

const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    padding: 12px 24px;
    color: #b31d15;
    cursor: pointer;
    background-color: #fff;
    border-radius: 100px;
    gap: 0.3rem;
    outline: solid 1px #b31d15;
`;
